import React from "react";
import { Typography } from "@material-ui/core/";
import Collapsable from "../Collapsable/Collapsable";
import ReactHtmlParser from "react-html-parser";
import DOMPurify from "dompurify";
import { DEFAULT_REBATE_MESSAGE } from "../../../constants";

export default function SummarySavings(props) {
  const { receiptData, rebatesMessage, zeroRebatesEndMessage } = props;

  if (Object.entries(receiptData).length !== 0) {
      let incentive = 0;
      const incentiveTotal = receiptData[0]?.incentive_total;
      if (incentiveTotal && incentiveTotal !== null &&
        incentiveTotal !== "" && incentiveTotal !== "0"
     ) incentive = incentiveTotal;

      const zeroRebatesValidation = zeroRebatesEndMessage?.isEnable && incentive === 0
          ? zeroRebatesEndMessage?.messageToShow
          // eslint-disable-next-line
          : rebatesMessage.replace("$${ incentive }", `$${incentive}`);

      return (
          <Collapsable title={"Your Savings"}>
              { (!zeroRebatesEndMessage?.isEnable || !zeroRebatesEndMessage?.messageToShow) && incentive === 0
                ? <>
                    <Typography color="secondary" variant="subtitle1" gutterBottom>
                        { 
                            // eslint-disable-next-line
                            rebatesMessage.replace("$${ incentive }", `$${incentive}`)
                        }
                    </Typography>
                    <Typography component="span" variant="body2" gutterBottom>
                      { ReactHtmlParser(DOMPurify.sanitize(DEFAULT_REBATE_MESSAGE)) }
                    </Typography>
                  </>
                : <Typography color="secondary" variant="subtitle1" gutterBottom>
                      { zeroRebatesValidation }
                  </Typography>
              }
          </Collapsable>
      );
  } else {
      return null;
  }
}
